var map = {
	"./comodo-secure.png": 963,
	"./flag-france.png": 964,
	"./flag-germany.png": 965,
	"./flag-italy.png": 966,
	"./flag-netherlands.png": 967,
	"./flag-portugal.png": 968,
	"./flag-spain.png": 969,
	"./flag-usa.png": 970,
	"./global-cart-seal.png": 971,
	"./icon-wanelo copy.png": 972,
	"./icon-wanelo.png": 973,
	"./icon-whatsapp copy.png": 974,
	"./icon-whatsapp.png": 975,
	"./lock.png": 976,
	"./pagamento-cinza.png": 977,
	"./pagamento-verde.png": 978,
	"./pagamento-vermelho.png": 979,
	"./payment-methods-br.png": 980,
	"./payment-methods-global.png": 981,
	"./payment-methods.png": 982,
	"./pedido-cinza.png": 983,
	"./pedido-verde.png": 984,
	"./pedido-vermelho.png": 985,
	"./selo-ebit-ouro.png": 986,
	"./selo-eureciclo.png": 987,
	"./selo-internet-segura.png": 988,
	"./selo-ra1000.png": 989,
	"./selo_100-seguro-retina.png": 266,
	"./selo_100-seguro.png": 990,
	"./selo_site_seguro_certisign.png": 991,
	"./selo_site_seguro_mcafee.png": 992,
	"./selo_site_seguro_norton.png": 993,
	"./selo_site_seguro_norton_small.png": 994,
	"./separacao-cinza.png": 995,
	"./separacao-verde.png": 996,
	"./separacao-vermelho.png": 997,
	"./shipping-methods-global.png": 998,
	"./transporte-cinza.png": 999,
	"./transporte-verde.png": 1000,
	"./transporte-vermelho.png": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 962;